import { gql } from "@apollo/client";
import { fragments as inkColorDetailsFragment } from "../../components/InkColorDetails/graph";

const updateOrderProductionJobCustomizationAreaColorsMutation = gql`
  mutation(
    $colors: [InkPantoneColorInput!]!
    $orderProductionJobCustomizationAreaId: ID!
  ) {
    updateOrderProductionJobCustomizationAreaColors(
      colors: $colors
      orderProductionJobCustomizationAreaId: $orderProductionJobCustomizationAreaId
    ) {
      errors {
        orderProductionJobCustomizationAreaId
        colors
        colorsInput {
          inkColorId
          pantoneColorId
        }
      }
      updatedOrderProductionJobCustomizationArea {
        id
        inkColors {
          customizationArea {
            id
          }
          id
          inkColor {
            ...InkColorDetails_inkColor
          }
          pantoneColor {
            ...InkColorDetails_pantoneColor
          }
        }
      }
      succeeded
    }
  }
  ${inkColorDetailsFragment.inkColor}
  ${inkColorDetailsFragment.pantoneColor}
`;

export default updateOrderProductionJobCustomizationAreaColorsMutation;
